import React from "react";
import { StateManager } from "../../rule-engine-core/Common/StateManager";
import { ObserveState } from "../StateManagement/ObserveState";
import { UIColorPickerTextField } from "../BuildlingBlocks/UIColorPickerTextField";
import { SxProps } from "@mui/material";
import { getPropertyEditorValidationIssues, PropertyEditorValidationTooltip } from "./PropertyEditorValidationTooltip";

export interface PropertyEditorColorInterface {
    editObject: object;
    propertyName: string;
    label?: string;
    hint?: string;
    color?: string | "secondary" | "default";
    name?: string;
    parentDefaultValue?: string | null;
    onChange?: () => void;
    sx?: SxProps;
    error?: string;
    ignoreDesignerValidation?: boolean;
}

export const PropertyEditorColor: React.FC<PropertyEditorColorInterface> = (props: PropertyEditorColorInterface) => {
    const onChange = (val: string | undefined) => {
        Reflect.set(props.editObject, props.propertyName, val);
        StateManager.propertyChanged(props.editObject, props.propertyName);
        if (props.onChange) props.onChange();
    };

    return (
        <>
            <ObserveState
                listenTo={props.editObject}
                properties={[props.propertyName]}
                control={() => {
                    const value = Reflect.get(props.editObject, props.propertyName) ?? props.parentDefaultValue;
                    let validationIssues = getPropertyEditorValidationIssues(
                        props.editObject,
                        props.propertyName,
                        props.error,
                    );
                    return (
                        <PropertyEditorValidationTooltip
                            editObject={props.editObject}
                            propertyName={props.propertyName}
                            error={validationIssues}
                        >
                            <UIColorPickerTextField
                                sx={{ width: "100%", ...props.sx }}
                                label={props.label}
                                hint={props.hint}
                                error={validationIssues?.message}
                                value={value}
                                onChange={onChange}
                            />
                        </PropertyEditorValidationTooltip>
                    );
                }}
            />
        </>
    );
};
